import { Component, Inject, OnInit } from '@angular/core';
import { EMasterSondeType } from 'src/app/domain/Shared/enum/master-sonde-type';
import { MasterSonde } from 'src/app/domain/Shared/master-sonde';
import { StringConverter } from '../string-converter';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-sonde-box',
    templateUrl: './sonde-box.component.html',
    styleUrls: ['./sonde-box.component.scss']
})
export class SondeBoxComponent implements OnInit {
    public IsCreation: boolean = false;
    public model: MasterSonde;
    public SondeTypeList: string[] = Object.values(EMasterSondeType)
        .filter(x => !isNaN(Number(x)))
        .map((x: EMasterSondeType) => StringConverter.getMasterSondeTypeName(x));

    constructor(
        public dialogRef: MatDialogRef<SondeBoxComponent>,
        @Inject(MAT_DIALOG_DATA) public data: MasterSonde
    ) {
        this.model = Object.assign({}, data);
        if (!data) {
           this.IsCreation = true;
        }
    }

    ngOnInit(): void {
    }

    CanAddSonde() {
        return this.model.Reference && this.model.FacteurCorrection && this.model.Type
    }

    onCancel(): void {
        this.dialogRef.close(null);
    }

    onConfirm() {
        this.dialogRef.close(this.model);
    }
}
